var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0445 27.9C7.42228 27.9 6.88894 27.6778 6.4445 27.2333C6.00005 26.7889 5.77783 26.2556 5.77783 25.6333V12.7333C5.77783 12.3778 5.85561 12.0389 6.01117 11.7167C6.16672 11.3944 6.38894 11.1222 6.67783 10.9L15.2778 4.46667C15.4778 4.31111 15.6945 4.19444 15.9278 4.11667C16.1612 4.03889 16.4001 4 16.6445 4C16.8889 4 17.1278 4.03889 17.3612 4.11667C17.5945 4.19444 17.8112 4.31111 18.0112 4.46667L26.6112 10.9C26.9001 11.1222 27.1223 11.3944 27.2778 11.7167C27.4334 12.0389 27.5112 12.3778 27.5112 12.7333V25.6333C27.5112 26.2556 27.2889 26.7889 26.8445 27.2333C26.4001 27.6778 25.8667 27.9 25.2445 27.9H19.3445V18.3333H13.9445V27.9H8.0445Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.44a537632e981aa80d8e4e90e465c0f8.svg";
export { ForwardRef as ReactComponent };